import type { ProjectCategoryDto } from './types'

/**
 * The categories a line can be put in: the visible ones, plus the hidden one the line already
 * uses (a hidden category stays on its lines, it is only out of the picker).
 */
export function pickableCategories(
  categories: readonly ProjectCategoryDto[],
  currentCategoryId: string | null | undefined
): ProjectCategoryDto[] {
  return categories.filter((c) => !c.isHidden || c.id === currentCategoryId)
}
